import { ProductKey } from '@/modules/estate/enums/ProductKey';

export abstract class CheckoutSessionProductDescription {
  abstract get productKey(): ProductKey;
  abstract get title(): string;
  abstract get inclusions(): string[];
  abstract get exclusions(): string[];

  get recurringProductKey(): ProductKey | undefined {
    return undefined;
  }

  get subtitle(): string | undefined {
    return undefined;
  }

  get legalDisclaimer(): string | undefined {
    return undefined;
  }

  get productKeys(): ProductKey[] {
    return [this.productKey, this.recurringProductKey].filter(
      (key: ProductKey | undefined): key is ProductKey => !!key
    );
  }
}
